import {Client} from "./../../models/Client";

// relations is overridden by clients-api
let contactsApi = (contactType, relations = [])=>{
    return {
        async get(token, companyId, params={}){
            let response = await window.axios.get('/api/'+contactType, {
                params:{
                    api_token:token,
                    company_logged:companyId,
                    ...params
                }
            });
            let dataMap = data=>data.map(it=>new Client(it))
            if(response.data.current_page)
                response.data.data = dataMap(response.data.data);
            else
                response.data = dataMap(response.data);
            return response.data;
        },
        async find(id, token, companyId,
                   fields=[], relationships= relations){
            let response = await window.axios.get('/api/'+contactType+'/'+id, {
                params:{
                    api_token:token,
                    company_logged:companyId,
                    fields: fields,
                    relationships: relationships,
                }
            });
            return new Client(response.data);
        },
        async create(client, token, companyId, params = {}){
            let response = await window.axios.post('/api/'+contactType, client, {
                params:{
                    api_token:token,
                    company_logged:companyId,
                    ...params
                }
            });
            return new Client(response.data);
        },
        async edit(client, token, companyId, params = {}){
            let response = await window.axios.put('/api/'+contactType+'/'+client.id, client, {
                params:{
                    api_token:token,
                    company_logged:companyId,
                    ...params
                }
            });
            return new Client(response.data);
        },
        async delete(client, token, companyId){
            let response = await window.axios.delete('/api/'+contactType+'/'+client.id, {
                params:{
                    api_token:token,
                    company_logged:companyId,
                }
            });
            return !!response.data.success;
        },
    }
}

export default contactsApi;